// @flow

const otherDocuments = {
  type: 'otherDocuments',
  selecting: true,
  selectAll: true,
  actions: [
    {
      icon: 'Delete',
      title: 'Delete',
      method: 'delete'
    }
  ],
  row: {
    click: true,
    action: 'modal',
    modal: {
      app: 'clients',
      tab: 'otherDocumentsInfo'
    }
  },

  cells: [
    { id: 'name', label: 'Name', align: 'left' },
    { id: 'created_date', label: 'Created', align: 'left', isDate: true },
    { id: 'modified_date', label: 'Modified', align: 'left', isDate: true },
    {
      id: 'attachment_link',
      label: 'Download',
      labelAlign: 'center',
      align: 'center',
      button: true,
      renderDowloadIcon: true,
      hideOrderBy: true,
      GAbutton: 'Download Other Document'
    }
  ]
};

export default otherDocuments;
